import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Main from './components/home/Main';

function App() {
  return (
    <Main />
  );
}

export default App;
